import { createFileRoute, redirect } from "@tanstack/react-router";

import { HostedMemorySettingsPanel } from "../components/hosted/HostedMemorySettingsPanel";
import { clerkProviderEnabled } from "../cloud/clerkRuntime";
import { settingsSectionRedirect } from "../hosted/hostedMode";

function SettingsMemoryRoute() {
  return <HostedMemorySettingsPanel />;
}

export const Route = createFileRoute("/settings/memory")({
  // Memory is stored by the hosted Worker and edited through its authenticated
  // routes, so a local or desktop client has nothing to show here. Redirecting
  // rather than rendering keeps a bookmarked or typed URL from mounting a panel
  // whose Clerk hooks would run with no provider above them.
  beforeLoad: ({ context }) => {
    const target = settingsSectionRedirect({
      authGateStatus: context.authGateState.status,
      clerkProviderMounted: clerkProviderEnabled(),
      path: "/settings/memory",
    });
    if (target) {
      throw redirect({ to: target, replace: true });
    }
  },
  component: SettingsMemoryRoute,
});
